import * as React from 'react';

import { ProgressTracker } from 'bundles/skills-common';

const SvgStartingScore: React.FC<{ hideTarget?: boolean }> = ({ hideTarget }) => (
  <div style={{ width: 320 }}>
    <ProgressTracker
      segments={[50, 150, 350]}
      hideTarget={hideTarget}
      target={hideTarget ? undefined : 180}
      maxScore={500}
    />
  </div>
);

export default SvgStartingScore;
